/**
 * tdesign v1.6.6
 * (c) 2023 tdesign
 * @license MIT
 */

import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { defineComponent, toRefs, getCurrentInstance, computed, provide } from '@vue/composition-api';
import getRenderAlign from './utils.js';
import _TimelineItem from './timeline-item.js';
import TimelineProps from './props.js';
import { usePrefixClass } from '../hooks/useConfig.js';
import '../_common/js/log/index.js';
import '../_common/js/log/log.js';
import '../loading/index.js';
import '../loading/directive.js';
import 'lodash/isObject';
import 'lodash/mapKeys';
import 'lodash/isEqual';
import '../loading/plugin.js';
import 'vue';
import '../loading/loading.js';
import '../loading/icon/gradient.js';
import '../_common/js/loading/circle-adapter.js';
import '../_common/js/utils/set-style.js';
import '../_common/js/utils/helper.js';
import '@babel/runtime/helpers/toConsumableArray';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import 'lodash/isString';
import 'lodash/isNull';
import 'lodash/isUndefined';
import 'lodash/isNumber';
import 'lodash/isArray';
import '../config-provider/config-receiver.js';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '@babel/runtime/helpers/typeof';
import '../_chunks/dep-fdafdce0.js';
import 'dayjs';
import '../_chunks/dep-9849f16c.js';
import '../config-provider/type.js';
import '../utils/mixins.js';
import '../utils/dom.js';
import 'raf';
import '../utils/easing.js';
import '../utils/render-tnode.js';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../utils/transfer-dom.js';
import '../loading/props.js';
import '../config.js';
import '../utils/withInstall.js';
import 'lodash/capitalize';
import './style/css.js';
import '../loading/type.js';
import './timeline-item-props.js';
import '../config-provider/useConfig.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _Timeline = defineComponent({
  name: "TTimeline",
  components: {
    TimelineItem: _TimelineItem
  },
  props: _objectSpread({}, TimelineProps),
  setup: function setup(props) {
    var _toRefs = toRefs(props),
      theme = _toRefs.theme,
      labelAlign = _toRefs.labelAlign,
      reverse = _toRefs.reverse,
      layout = _toRefs.layout,
      mode = _toRefs.mode;
    var instance = getCurrentInstance();
    var classPrefix = usePrefixClass();
    var hasLabelItem = computed(function () {
      var defaultSlots = instance.slots["default"] ? instance.slots["default"] : [null];
      return defaultSlots.some(function (item) {
        var _item$componentOption;
        return !!(item !== null && item !== void 0 && (_item$componentOption = item.componentOptions) !== null && _item$componentOption !== void 0 && (_item$componentOption = _item$componentOption.propsData) !== null && _item$componentOption !== void 0 && _item$componentOption.label);
      });
    });
    var timelineClassName = computed(function () {
      var renderAlign = getRenderAlign(labelAlign === null || labelAlign === void 0 ? void 0 : labelAlign.value, layout === null || layout === void 0 ? void 0 : layout.value);
      var classNames = ["".concat(classPrefix.value, "-timeline"), "".concat(classPrefix.value, "-timeline-").concat(renderAlign), "".concat(classPrefix.value, "-timeline-").concat(layout === null || layout === void 0 ? void 0 : layout.value), "".concat(classPrefix.value, "-timeline-label--").concat(mode === null || mode === void 0 ? void 0 : mode.value)];
      if (reverse !== null && reverse !== void 0 && reverse.value) {
        classNames.push("".concat(classPrefix.value, "-timeline-reverse"));
      }
      if (hasLabelItem !== null && hasLabelItem !== void 0 && hasLabelItem.value) {
        classNames.push("".concat(classPrefix.value, "-timeline-label"));
      }
      return classNames.join(" ");
    });
    provide("TTimeline", {
      theme: theme,
      labelAlign: labelAlign,
      reverse: reverse,
      layout: layout,
      mode: mode,
      timelineClassName: timelineClassName.value
    });
    return {
      timelineClassName: timelineClassName
    };
  },
  render: function render() {
    var h = arguments[0];
    var reverse = this.reverse;
    var defaultSlot = this.$scopedSlots["default"] ? this.$scopedSlots["default"](null) : [null];
    if (reverse) {
      defaultSlot.reverse();
    }
    var timelineClassName = this.timelineClassName,
      style = this.style;
    return h("ul", {
      "class": timelineClassName,
      "style": style
    }, [defaultSlot]);
  }
});

export { _Timeline as default };
//# sourceMappingURL=timeline.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/tdesign-vue/es/timeline/timeline.js
// module id = null
// module chunks = 